import React from "react"
import styled from "styled-components"

import { Box, Flex } from "components/box"
import Image from "components/image"
import { H4, Paragraph } from "components/text"
import { PrimaryButton } from "components/buttons"

import bgBox from "assets/backgrounds/beam-box@2x.png"

import { Height } from "theme"

const Container = styled(Flex)`
  justify-content: space-between;
  width: 100%;
  background-color: rgba(255, 181, 130, 0.1);
  flex-direction: column-reverse;
  text-align: center;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}px) {
    flex-direction: row;
    text-align: left;
  }
`

const PeachButton = styled(PrimaryButton)`
  background-color: #ffb07b;
  color: ${props => props.theme.colors.charcoal};
  font-size: 1.125rem;

  &:after {
    content: none;
  }

  ${props =>
    !props.loading &&
    `
    :hover:not([disabled]), :active {
      background-color: #ff865f;
      color: ${props.theme.colors.white};
    }

    :focus:not([disabled]) {
      outline-color: ${props.theme.colors.coolGrey};
    }
  `}
`

const ImgHeight = [128, null, 178] as Height

export const BeamUpsellBanner: React.FC = () => (
  <Container color="evergreen" mb={5} mt={[5, null, 7]} py={[5, null, 6]} pl={[5, null, 6]} pr={[5, null, 1]}>
    <Box>
      <H4 mt={[4, null, 0]}>Introducing Cove Beam</H4>
      <Paragraph mt={[3, null, 4]} color="gunmetal">
        The all new <strong>3-in-1 supplement</strong> to support migraine sufferers.
      </Paragraph>
      <PeachButton color="peach" mt={5} href="https://get.withcove.com/beam-1" width={["80%", null, "50%"]}>
        Learn More
      </PeachButton>
    </Box>
    <Image height={ImgHeight} inheritSizes ml={[5, null, 4]} src={bgBox} />
  </Container>
)
